import React from 'react';

import { createClassName } from 'utils/createClassName';

import './floatingLabelStyles.scss';

type Props = {
  titleText: React.ReactNode;
  hintText?: React.ReactNode;
  lifted?: boolean;
  invalid?: boolean;
  withoutBorder?: boolean;
};

export const FloatingLabelComponent: React.FC<Props> = (props) => {
  const {
    titleText,
    hintText,
    lifted,
    invalid,
    withoutBorder,
    children,
  } = props;

  const createFloatingLabelClassName = createClassName('floatingLabel');

  const wrapperClassName = createFloatingLabelClassName('wrapper', {
    lifted,
    invalid,
    withoutBorder,
  });

  const titleClassName = createFloatingLabelClassName('title', {
    lifted,
    invalid,
    withoutBorder,
  });

  const controlClassName = createFloatingLabelClassName('control', {
    lifted,
    invalid,
    withoutBorder,
  });

  const hintClassName = createFloatingLabelClassName('hint', {
    lifted,
    invalid,
    withoutBorder,
  });

  return (
    <label className={wrapperClassName}>
      <div className={titleClassName}>{titleText}</div>
      <div className={controlClassName}>{children}</div>
      <div className={hintClassName}>{hintText}</div>
    </label>
  );
};
